// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-mouseleave
{
    box-shadow: 0 0 0px 0px rgba(0, 0, 0, 0.5);      
    -webkit-user-select: none;      
            user-select: none;
}

.icon-mouseenter
{
        box-shadow: 0 0 15px 5px rgba(64, 64, 64, 0.2);
        background-color: rgba(64, 64, 64, 0.1);
        -webkit-user-select: none;
                user-select: none;
        
}



.icon-mouseup
{
    transform: scale(1); 
    -webkit-user-select: none; 
            user-select: none;
}

.icon-mousedown
{
    transform: scale(0.9); /* Agrandir de 50% au survol */
    -webkit-user-select: none;
            user-select: none;
}


.icon-textmouseup
{
    display: inline-block;
    transform: scale(1); 
    transform: translate(0px, -4px);
    -webkit-user-select: none;
            user-select: none;
}


.icon-textenter
{
    display: inline-block;
    box-shadow: 0px 0px 30px rgba(64, 64, 64, 1);
    background-color: rgba(64, 64, 64, 0.1);
    -webkit-user-select: none;
            user-select: none;
        
}

.icon-textmousedown
{
    display: inline-block;
    transform: translate(-1px, -2px);
    -webkit-user-select: none;
            user-select: none;
}


`, "",{"version":3,"sources":["webpack://./src/components/bases/icone/icon.css"],"names":[],"mappings":"AAAA;;IAEI,0CAA0C;IAC1C,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;;QAEQ,8CAA8C;QAC9C,uCAAuC;QACvC,yBAAiB;gBAAjB,iBAAiB;;AAEzB;;;;AAIA;;IAEI,mBAAmB;IACnB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;;IAEI,qBAAqB,EAAE,8BAA8B;IACrD,yBAAiB;YAAjB,iBAAiB;AACrB;;;AAGA;;IAEI,qBAAqB;IACrB,mBAAmB;IACnB,+BAA+B;IAC/B,yBAAiB;YAAjB,iBAAiB;AACrB;;;AAGA;;IAEI,qBAAqB;IACrB,4CAA4C;IAC5C,uCAAuC;IACvC,yBAAiB;YAAjB,iBAAiB;;AAErB;;AAEA;;IAEI,qBAAqB;IACrB,gCAAgC;IAChC,yBAAiB;YAAjB,iBAAiB;AACrB","sourcesContent":[".icon-mouseleave\n{\n    box-shadow: 0 0 0px 0px rgba(0, 0, 0, 0.5);      \n    user-select: none;\n}\n\n.icon-mouseenter\n{\n        box-shadow: 0 0 15px 5px rgba(64, 64, 64, 0.2);\n        background-color: rgba(64, 64, 64, 0.1);\n        user-select: none;\n        \n}\n\n\n\n.icon-mouseup\n{\n    transform: scale(1); \n    user-select: none;\n}\n\n.icon-mousedown\n{\n    transform: scale(0.9); /* Agrandir de 50% au survol */\n    user-select: none;\n}\n\n\n.icon-textmouseup\n{\n    display: inline-block;\n    transform: scale(1); \n    transform: translate(0px, -4px);\n    user-select: none;\n}\n\n\n.icon-textenter\n{\n    display: inline-block;\n    box-shadow: 0px 0px 30px rgba(64, 64, 64, 1);\n    background-color: rgba(64, 64, 64, 0.1);\n    user-select: none;\n        \n}\n\n.icon-textmousedown\n{\n    display: inline-block;\n    transform: translate(-1px, -2px);\n    user-select: none;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
